<template>
  <div class="content">
    <h1 class="has-text-centered">USB 3.0 Pins</h1>
    <div class="box">
      <p class="is-size-7-mobile">
          USB (Universal Serial Bus) ist ein bit-serielles Datenübertragungssystem.
      </p>
    </div>
    <div class="box has-text-centered">
      <img src="@/assets/images/pinouts/Pinout-USB-3-0.jpg">
    </div>
    <div class="box">
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped is-bordered has-text-centered is-size-7-mobile">
          <thead>
            <tr>
              <th class="th-pins">Pin</th>
              <th class="th-pins">Name</th>
              <th class="th-pins">Farbe</th>
              <th class="th-pins">Beschreibung</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>VBUS</td>
              <td>+5 Volt</td>
              <td>Rot</td>
            </tr>
            <tr>
              <td>2</td>
              <td>D-</td>
              <td>Hi-Speed Datenleitung</td>
              <td>Weiß</td>
            </tr>
            <tr>
              <td>3</td>
              <td>D+</td>
              <td>Hi-Speed Datenleitung</td>
              <td>Grün</td>
            </tr>
            <tr>
              <td>4</td>
              <td>GND</td>
              <td>Masse</td>
              <td>Schwarz</td>
            </tr>
            <tr>
              <td>5</td>
              <td>
                USB-A: SSRX-<br>
                USB-B: SSTX-
              </td>
              <td>SuperSpeed Datenleitung (Sender)</td>
              <td>Blau</td>
            </tr>
            <tr>
              <td>6</td>
              <td>
                USB-A: SSRX+<br>
                USB-B: SSTX+
              </td>
              <td>SuperSpeed Datenleitung (Sender)</td>
              <td>Gelb</td>
            </tr>
            <tr>
              <td>7</td>
              <td>GND_DRAIN</td>
              <td>Masse für SuperSpeed Datenleitungen</td>
              <td>nicht isoliert / keine Farbe</td>
            </tr>
            <tr>
              <td>8</td>
              <td>
                USB-A: SSTX-<br>
                USB-B: SSRX-
              </td>
              <td>SuperSpeed Datenleitung (Empfänger)</td>
              <td>Violett</td>
            </tr>
            <tr>
              <td>9</td>
              <td>
                USB-A: SSTX+<br>
                USB-B: SSRX+
              </td>
              <td>SuperSpeed Datenleitung (Empfänger)</td>
              <td>Orange</td>
            </tr>
            <tr>
              <th class="th-pins" colspan="4">nur USB-3.0-Typ-B (Powered)</th>
            </tr>
            <tr>
              <td>10</td>
              <td>DPWR</td>
              <td>Stromversorgung für USB-Gerät</td>
              <td>keine Vorgabe</td>
            </tr>
            <tr>
              <td>11</td>
              <td>DGND</td>
              <td>Masse für DPWR</td>
              <td>keine Vorgabe</td>
            </tr>
            <tr>
              <th class="th-pins" colspan="4">nur Micro-USB-3.0-Typ-B</th>
            </tr>
            <tr>
              <td>(4)</td>
              <td>ID</td>
              <td>Identifikation</td>
              <td>kein Kabel</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pins-usb',
  metaInfo: {
    title: 'USB Pins | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'USB (Universal Serial Bus) ist ein bit-serielles Datenübertragungssystem.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'pins' })
  }
}
</script>
